import React from 'react'
import * as Components from 'antd';

export default ({ ...rest }: any) => {
    return <Components.Popconfirm {...rest}
        destroyTooltipOnHide
        arrowPointAtCenter trigger='click'/>
}